import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';

import $ from 'jquery';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import Input from '../../components/Form/Input';
import Select from '../../components/Form/Select';
import FormButton from '../../components/Form/Button';
import { useEffect } from 'react';
import Textarea from '../../components/Form/Textarea';
import FormSelect from '../../components/Form/FormSelect';
import { useParams } from 'react-router-dom';

const FaqRequestEdit = () => {
      const { faqId } = useParams();

      const [faq, setFaq] = useState([]);
      const [types, setTypes] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const [question, setQuestion] = useState('');
      const [answer, setAnswer] = useState('');
      const [type, setType] = useState('');
      const [status, setStatus] = useState('');
      const [loading, setLoading] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadData = async () => {
            setLoadingData(true);
            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/faqs/types/list`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setTypes(response.data.types);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/faq_requests/${faqId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setFaq(response.data.faq);
                              setQuestion(response.data.faq.question);
                              setAnswer(response.data.faq.answer);
                              setStatus(response.data.faq.status);
                              setType(response.data.faq.faq_type_id);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  question: question ? question : faq.question,
                  answer: answer ? answer : faq.answer,
                  faq_type_id: type ? type : faq.faq_type,
                  status: status ? status : faq.status
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/faq_requests/${faqId}`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                              $('form').trigger('reset');
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.question) {
                                    toast.error(response.data.message.question);
                              }
                              if (response.data.message.faq_type_id) {
                                    toast.error(
                                          response.data.message.faq_type_id
                                    );
                              }
                              if (response.data.message.answer) {
                                    toast.error(response.data.message.answer);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                        setLoading(false);
                  });
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader>
                                                <CardTitle>
                                                      Create New Faq
                                                </CardTitle>
                                                <CardLinks>
                                                      <LinkButton to="/dashboard/faq_requests">
                                                            Back
                                                      </LinkButton>
                                                </CardLinks>
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <Input
                                                            title="Question"
                                                            value={question}
                                                            classes={12}
                                                            required={true}
                                                            handleChange={
                                                                  setQuestion
                                                            }
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            title="Faq Type"
                                                            selected={type}
                                                            required={true}
                                                            options={types}
                                                            setData={setType}
                                                      />
                                                      <Select
                                                            title="Status"
                                                            classes={6}
                                                            selected={status}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <Textarea
                                                            title="Answer"
                                                            required={true}
                                                            value={answer}
                                                            handleChange={
                                                                  setAnswer
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Submit"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default FaqRequestEdit;
